module.exports = __webpack_public_path__ + "img/rqyh@2x.b5075431.png";